import { Route } from "@gravity-ui/icons";
import { Card, Flex, Icon, Label, Text } from "@gravity-ui/uikit";
import { OrderList } from "definitions/poizon-api";

import { OrderViews } from "../../store/atoms/orderListView";
import css from "./OrderComponentTable.module.scss";
interface OrderProps {
  order: OrderList;
  view: OrderViews;
}
export const OrderComponentTable = ({ order }: OrderProps) => {
  const data = order;
  return (
    <Card className={css.orderCard} view="outlined" size="l">
      <img src={data.skuInfo.skuPic} />
      <Flex direction="column" alignItems="center">
        <div className={css.cardCaption}>
          <Card className={css.priceContainer}>
            <Icon data={Route} />
            <Text variant="subheader-2">{data.skuInfo.skuPrice / 100} ¥</Text>
            <Text variant="body-2" color="hint">
              {data.skuInfo.skuProp}x{data.skuInfo.skuQuantity}
            </Text>
          </Card>
        </div>
      </Flex>

      <Flex
        direction="column"
        gap="1"
        justifyContent="start"
        alignItems="start"
      >
        <Text className={css.skuTitle}>{data.skuInfo.spuTitle}</Text>
        <Flex
          justifyContent="start"
          direction="row"
          width="100%"
          gap="2"
          wrap="wrap"
        >
          <div>
            <Label theme="info" size="xs">
              {data.skuInfo.skuTagDesc}
            </Label>
          </div>
          <div>
            <Label type="copy" copyText={data.skuInfo.articleNumber}>
              {data.skuInfo.articleNumber}
            </Label>
          </div>
        </Flex>
      </Flex>
    </Card>
  );
};
